import React from 'react';
import Button from '../../../shared/components/ui/Button';

const ChequeTable = ({ chequeData, onAddCheque, onViewCheque, onDeleteCheque }) => {
  return (
    <div className="bg-white rounded-t-lg relative overflow-scroll hide-scrollbar shadow-sm border border-gray-200">
      {chequeData && chequeData.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="text-left w-full min-w-[800px]">
            <thead className="bg-gray-200 !text-gray-600 w-full">
              <tr className="font-normal h-[3rem] w-full whitespace-nowrap">
                <th className="px-4 py-2 border-b font-normal">Cheque Number</th>
                <th className="px-4 py-2 border-b font-normal">Amount</th>
                <th className="px-4 py-2 border-b font-normal">Date</th>
                <th className="px-4 py-2 border-b font-normal">Account Holder</th>
                <th className="px-4 py-2 border-b font-normal">Bank Name</th>
                <th className="px-4 py-2 border-b font-normal">IFSC Code</th>

                {/* <th className="px-4 py-2 border-b font-normal">Status</th>
                  <th className="px-4 py-2 border-b font-normal">Actions</th> */}
              </tr>
            </thead>
            <tbody>
              {chequeData?.map((cheque, index) => (
                <tr
                  key={cheque.id || index}
                  className="border-b hover:bg-gray-50 bg-white h-[3.5rem]">
                  <td className="px-4 py-2 text-sm">{cheque.cheque_number || '---'}</td>
                  <td className="px-4 py-2 text-sm">
                    ₹{new Intl.NumberFormat('en-IN').format(cheque.amount || 0)}
                  </td>
                  <td className="px-4 py-2 text-sm">
                    {cheque.date ? new Date(cheque.date).toLocaleDateString('en-IN') : '---'}
                  </td>
                  <td className="px-4 py-2 text-sm">{cheque.account_holder_name || '---'}</td>
                  <td className="px-4 py-2 text-sm">{cheque.bank_name || '---'}</td>
                  <td className="px-4 py-2 text-sm">{cheque.ifsc_code || '---'}</td>
                  {/* <td className="px-4 py-2 text-sm">
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-medium ${
                          cheque.status === 'cleared' || cheque.status === 'Cleared'
                            ? 'bg-green-100 text-green-800'
                            : cheque.status === 'bounced' || cheque.status === 'Bounced'
                              ? 'bg-red-100 text-red-800'
                              : 'bg-yellow-100 text-yellow-800'
                        }`}>
                        {cheque.status || 'Pending'}
                      </span>
                    </td>
                    <td className="px-4 py-2">
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => onViewCheque(cheque)}
                          className="h-8 w-8 grid place-items-center bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors duration-200"
                          title="View Details">
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24">
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                            />
                          </svg>
                        </button>
                        <button
                          onClick={() => onDeleteCheque(cheque)}
                          className="h-8 w-8 grid place-items-center bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors duration-200"
                          title="Delete">
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24">
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            />
                          </svg>
                        </button>
                      </div>
                    </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center py-10">
          <div className="flex flex-col items-center justify-center">
            <svg
              className="w-16 h-16 text-gray-300 mb-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <h2 className="text-lg font-bold text-gray-800 mb-2">No Cheques Found</h2>
            <p className="text-gray-600 text-sm mb-4">
              No cheques have been added for this deal yet.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChequeTable;
